import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const BrowserUpdatedIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"browser_updated"} ref={ref}/>
});

BrowserUpdatedIcon.displayName = "BrowserUpdatedIcon";
